
export const getBrand = (brands, unit) => {

    if(unit?.brand && unit.brand?.name){
        const brandFound = brands.find(element => {
            return String(element.acf.nome_da_marca ?? '').toLowerCase() === String(unit.brand.name).toLowerCase();
        });
    
        return brandFound;

    }

    return null;

}